export const SITE_PHOTO_FILTERS_BUTTON_FRENCH_LOCALE = {
  sortBy: {
    date: "Date",
    photoType: "Type de photo",
  },
  photoType: "Type de photo",
};
